import { useEffect, useState } from "react";
import { Phone, MessageSquare } from "lucide-react";
import { BRAND } from "@/data/content";
import { trackEvent } from "@/lib/analytics";

/**
 * Sticky mobile CTA bar — fixed to bottom on phones only.
 * Auto-hides at the very top of the hero (first 400px) so it doesn't
 * fight the hero CTAs, and reappears as soon as user scrolls.
 */
export default function MobileStickyBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-bar"
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 border-t border-ng-blue/40 bg-ng-bg/95 backdrop-blur-xl transition-transform duration-500 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="grid grid-cols-2 divide-x divide-ng-blue/25">
        <a
          href={`tel:${BRAND.phone_link}`}
          data-testid="mobile-sticky-call"
          onClick={() => trackEvent("mobile_call_click", { source: "sticky_bar" })}
          className="flex items-center justify-center gap-2 py-4 uppercase tracking-[0.18em] text-[11px] font-bold font-display text-white hover:text-ng-blue transition-colors active:bg-ng-blue/10"
        >
          <Phone size={14} strokeWidth={2} className="text-ng-blue" />
          Call Coach J
        </a>
        <a
          href={`sms:${BRAND.phone_link}`}
          data-testid="mobile-sticky-text"
          onClick={() => trackEvent("mobile_text_click", { source: "sticky_bar" })}
          className="flex items-center justify-center gap-2 py-4 uppercase tracking-[0.18em] text-[11px] font-bold font-display text-white bg-ng-blue/95 hover:bg-ng-blueLight transition-colors active:brightness-110"
        >
          <MessageSquare size={14} strokeWidth={2} />
          Text Coach J
        </a>
      </div>
    </div>
  );
}
